import axios from 'axios';

import { AppDispatch } from '../../reducer/store';
import { getToken } from '../axiosToken';

import { reducerGetApplicationsList, reducerApplicationFiltersList } from '../../reducer/recruiting/reducers/reducerApplicationForm';
import { reducerGetSingleApplication, reducerSingleApplicationStatus } from '../../reducer/recruiting/reducers/reducerSingleApplication';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetApplicationsList =
	(limit: number, page: number) => async (dispatch: AppDispatch, getState: () => any) => {
		const { token } = await getToken();
		axios.defaults.headers.common['Authorization'] = token;
		const store = getState();
		const filter = store.recruiting.applicationsList.applicationListInputValues;
		try {
			const response = await axios.post(
				`${BASE_URL}/json/projects/application/list`,
				{limit, page, ...filter} 
			);
			dispatch(reducerGetApplicationsList(response.data))
    } catch {
      console.log('err');
    };
	};

  export const actionGetSingleApplication = (id: string) => async (dispatch: AppDispatch) => {
		const { token } = await getToken();
		axios.defaults.headers.common['Authorization'] = token;
		try {
			const response = await axios.get(
				`${BASE_URL}/json/projects/application/${id}`
			);
			dispatch(reducerGetSingleApplication(response.data));
    } catch {
      console.log('err');
    };
	};

  export const actionCreateApplication = (data: any) => async (dispatch: AppDispatch) => {
		const { token } = await getToken();
		axios.defaults.headers.common['Authorization'] = token;
		try {
			const response = await axios.post(
				`${BASE_URL}/json/projects/application`, data
			);
			dispatch(reducerSingleApplicationStatus(200));
			dispatch(reducerGetSingleApplication(response.data));
			return response;
		} catch (e: any) {
			dispatch(reducerSingleApplicationStatus(400));
			return e.response;
		}
	};

	export const actionGetApplicationsFilters =
	(limit: number, page: number) => async (dispatch: AppDispatch, getState: () => any) => {
		const { token } = await getToken();
		axios.defaults.headers.common['Authorization'] = token;

		const store = getState();
		const filter = store.recruiting.applicationsList.applicationListInputValues;
		try {
			const response = await axios.post(
				`${BASE_URL}/json/projects/application/list`,
				{limit, page, ...filter} 
			);
			dispatch(reducerGetApplicationsList(response.data));
    } catch {
      console.log('err');
    };
	};

	export const actionApplicationFilters = () => async (dispatch: AppDispatch, getState: () => any) => {
		const { token } = await getToken();
			axios.defaults.headers.common['Authorization'] = token;
			try {
				const response = await axios.get(
					`${BASE_URL}/json/projects/application/filter`
				);
				dispatch(reducerApplicationFiltersList({ data: response.data }));
			} catch {
				console.log('err');
			};
	}

	export const actionTest =
  (id: any) => async (dispatch: AppDispatch) => {
  };